import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Color } from 'app/shared/models/class/color/color';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColorService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getColors(): Observable<Color[]> {
    return this.http.get<Color[]>(`${environment.apiUrl}/Color/GetColors`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  updateOrderColor(colors: Color[]) {
    const listKey = colors.map(c => c.colorKey);
    return this.http.post(`${environment.apiUrl}/Color/UpdateColorsOrder`, listKey);
  }
}
